import { _isIosDevice } from './helpers';

export const addIosClass = () => {
  /*
    add ios class to body tag to fix fixed button being 
    pushed below the screen on ios devices
  */
  if (_isIosDevice()) {
    const body = document.querySelector('body');
    if (body) {
      body.classList.add('is-ios-device');
    }
  }
};
